<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="row">
      <div class="col-lg-8">
        <base-button type="primary" @click.prevent="onNew" icon>
          <span class="btn-inner--icon">
            <i class="ni e-add"></i>
          </span>New transaction
        </base-button>
        <base-button type="info" @click.prevent="onRefresh" icon>
          <span class="btn-inner--icon">
            <i class="ni refresh-02"></i>
          </span>Refresh
        </base-button>
      </div>
      <div class="col-lg-4">
        <base-input v-model="search" prepend-icon="fas fa-search" placeholder="Search..."></base-input>
      </div>
    </div>
    <el-table :data="ds" row-key="id" header-row-class-name="thead-light">
      <el-table-column label="Student" prop="studentname"></el-table-column>
      <el-table-column label="Pay date" prop="paydate"></el-table-column>
      <el-table-column label="Amount" prop="amount"></el-table-column>
      <el-table-column label="currency" prop="currency"></el-table-column>
      <el-table-column label="rate" prop="rate"></el-table-column>
      <el-table-column label="type" prop="paytypename"></el-table-column>
      <el-table-column min-width="120px" align="right" label="Actions">
        <div slot-scope="{row}" class="d-flex">
          <base-button @click.native="onEdit(row)" class="edit" type="warning" size="sm" icon>
            <i class="text-white ni n-edit"></i>
          </base-button>
          <base-button
            @click.native="onDelete(row)"
            class="remove btn-link"
            type="danger"
            size="sm"
            icon
          >
            <i class="text-white ni e-remove"></i>
          </base-button>
        </div>
      </el-table-column>
    </el-table>

    <modal :show.sync="modalform">
      <h6 slot="header" class="modal-title">Transaction</h6>
      <validation-observer ref="formvalid">
        <div class="row">
          <div class="col-lg-12" v-if="payerType === 1">
            <base-input label="Student" rules="required" name="Student">
              <el-select
                class="select-primary pagination-select"
                v-model="tran.studentid"
                placeholder="Student"
              >
                <el-option
                  class="select-primary"
                  v-for="item in students"
                  :key="item.studentId"
                  :label="item.fullname"
                  :value="item.studentId"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input label="Pay date" rules="required" name="Pay date">
              <flat-picker
                :config="{allowInput: true, }"
                class="form-control datepicker"
                v-model="tran.paydate"
              ></flat-picker>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              type="number"
              label="Amount"
              placeholder="Amount"
              v-model="tran.amount"
              name="amount"
              rules="required"
            ></base-input>
          </div>
          <div class="col-lg-6">
            <base-input label="Currency" rules="required" name="Currency">
              <el-select
                class="select-primary pagination-select"
                v-model="tran.currency"
                placeholder="Currency"
              >
                <el-option
                  class="select-primary"
                  v-for="item in currency"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input label="Pay type" rules="required" name="Pay type">
              <el-select
                class="select-primary pagination-select"
                v-model="tran.paytype"
                placeholder="Pay type"
              >
                <el-option
                  class="select-primary"
                  v-for="item in types"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              type="number"
              label="Rate"
              placeholder="Rate"
              v-model="tran.rate"
              name="rate"
              rules="required"
            ></base-input>
          </div>
          <div class="col-lg-6">
            <base-input type="text" label="Info" placeholder="Info" v-model="tran.info" name="info"></base-input>
          </div>
        </div>
      </validation-observer>
      <div class="text-center">
        <base-button type="primary" @click.native="onSave()">Save changes</base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import { Table, TableColumn, Select, Option, Tabs, TabPane } from "element-ui";
import { Modal, BaseAlert } from "@/components";
import { PaymentTranType } from "../../../services/types";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  GetTran,
  DeleteTran,
  CreateTran,
  UpdateTran,
} from "../../../services/payments";
import { GetStudents } from "../../../services/classes";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "payment-tran",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    Modal,
    Loading,
    flatPicker,
  },
  props: {
    paymentId: String,
    classId: String,
    payerType: Number,
  },
  computed: {
    ds() {
      return this.tableData.filter(
        (c) =>
          !this.search ||
          (this.search !== "" &&
            c.studentname.toLowerCase().indexOf(this.search) > -1)
      );
    },
  },
  data() {
    return {
      search: "",
      tableData: [],
      students: [],
      isLoading: false,
      modalform: false,
      tran: {},
      pid: this.paymentId,
      types: [
        { id: 1, name: "cash" },
        { id: 2, name: "transfer" },
        { id: 3, name: "online" },
      ],
      currency: ["AZN", "USD", "EUR", "RUB"],
    };
  },
  methods: {
    getStudents() {
      if (!this.classId) return;
      GetStudents(this.classId).then((response) => {
        if (response.data.result) {
          this.students = response.data.result;
        } else {
          this.students = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    loadTran() {
      if (!this.paymentId) return;
      this.isLoading = true;

      GetTran(this.paymentId).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onNew() {
      this.tran = new PaymentTranType();
      this.tran.paymentid = this.paymentId;
      this.getStudents();
      this.modalform = true;
    },
    onEdit(row) {
      this.tran = Object.assign({}, row);
      this.getStudents();
      this.modalform = true;
    },
    onSave(status) {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (!this.tran.id) {
            CreateTran(this.tran).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.notifyVue("success");

                this.loadTran();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdateTran(this.tran).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.loadTran();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    onRefresh() {
      this.loadTran();
    },
    onDelete(row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            DeleteTran(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.loadTran();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
  },
  mounted() {
    this.loadTran();
    if (this.payerType === 1) this.getStudents();
  },
};
</script>

<style lang="scss" scoped>
</style>